<template>

	<div class="form group">

		<label class="label" :id="label_id" :for="input_id" v-html="$t('auto_complete.address')"></label>

		<div class="row">
			<div class="col-9" role="combobox" aria-haspopup="listbox" :aria-expanded="isOpen">
				<input class="form-control"
					type="text" 
					@input="on_change" 
					v-model="search" 
					@keyup.down="on_arrow_down" @keyup.up="on_arrow_up" @keyup.enter="on_enter" aria-multiline="false"
					role="searchbox"
					aria-autocomplete="list" 
					aria-controls="autocomplete-results"
					:aria-activedescendant="activeDescendent"
					:aria-labelledby="label_id"
					:placeholder="$t('auto_complete.placeholder')"
					@focus="set_focus"
				/>

				<ul id="autocomplete-results" v-show="isOpen" class="autocomplete-results" role="listbox">
					<li class="loading" v-if="isLoading" v-html="$t('auto_complete.loading_results')"></li>
					<li class="loading" v-if="noResults" v-html="$t('auto_complete.no_results')"></li>
					<li v-else v-for="(result, i) in results" :key="i" @click="set_result(result,i)" class="autocomplete-result" :class="{ 'is-active': is_selected(i) }"
					role="option"
					:id="get_id(i)"
					:aria-selected="is_selected(i)">{{ result | address_label }}
					</li>
				</ul>
			</div>
			<div class="col-3">
				<button v-if="search" type="button" class="btn btn-light" @click="clear">{{ $t('auto_complete.clear') }}</button>
			</div>
		</div>
		<small class="form-text text-muted">
			{{ $t('auto_complete.street_num_and_name') }}
		</small>

	</div>

</template>

<script>

window.ac_count = (window.ac_count) ? window.ac_count + 1 : 1;

export default {
	props: {
		items: {
			type: Array,
			required: false,
			default: () => { return [] },
		},
		isAsync: {
			type: Boolean,
			required: false,
			default: false
		},
		ariaLabelledBy: {
			type: String,
			required: true
		}
	},


	data() {
		return {
			isOpen: false,
			results: [],
			search: "",
			search_no_type: "",
			isLoading: false,
			noResults: false,
			arrowCounter: 0,
			activeDescendent: "",
			activated: false,
			nounce: '',
			id: Math.round(Math.random * 100000),
			cleared: false,
		}
	},
	
	filters: {
		address_label(result, no_street_type) {
			let label = '';
			if (result.unit_number) {
				label = result.unit_number + '-';
			}
			return label + result.street_number + ' ' + result.street_name + ((!no_street_type) ? ' ' + result.street_type : '');
		}
	},

	computed: {
		label_id() {
			return 'ac-label-id-' + this.id;
		},
		input_id() {
			return 'ac-input-id-' + this.id;
		}
	},

	methods: {
		make_label(result,no_street_type) {
			let label = '';
			if (result.unit_number) {
				label = result.unit_number + '-';
			}
			return label + result.street_number + ' ' + result.street_name + ((!no_street_type) ? ' ' + result.street_type : '');
		},

		is_selected(index) {
			return index === this.arrowCounter;
		},

		set_focus() {
			this.search = this.search_no_type;
		},

		clear() {
			this.search = '';
			this.search_no_type = '';
			this.cleared = true;
			this.noResults = false;
			this.$emit('cleared');
		},

		get_id(index) {
			return this.nounce + "-result-option-" + index;
		},

		set_result(result,idx) {
			this.search = this.make_label(result);
			//result.street_number + ' ' + result.street_name + ' ' + result.street_type;
			this.search_no_type = this.make_label(result,false);
			this.isOpen = false;
			this.results = [];
			this.activated = false;
			this.$emit('set-result',result,idx);
		},

		on_change() {
			this.activated = true;
			// Let's warn the parent that a change was made
			this.$emit("input", this.search);
			this.isOpen = true;

			// Is the data given by an outside ajax request?
			if (this.isAsync) {
				this.isLoading = true;
			} else {
			// Let's search our flat array
				this.filter_results();
			}
		},

		filter_results() {
			this.items.filter(item => {
				return item.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
			})
		},

		set_active_descendent: function() {
			this.activeDescendent = this.get_id(this.arrowCounter);
		},

		on_arrow_down() {
			if (this.isOpen) {
				if (this.arrowCounter < this.results.length - 1) {
					this.arrowCounter = this.arrowCounter + 1;
					this.set_active_descendent();
				}
			}
		},

		on_arrow_up() {
			if (this.isOpen) {
				if (this.arrowCounter > 0) {
					this.arrowCounter = this.arrowCounter - 1;
					this.set_active_descendent();
				}
			}
		},

		on_enter() {
			if (this.results.length) {
				if (this.arrowCounter >= 0) {
					this.set_result(this.results[this.arrowCounter],this.arrowCounter);
				} else if(this.results.length && this.results[0]) {
					this.set_result(this.results[0],0);
				}
			}
			this.arrowCounter = -1;
		},

		handle_click_outside(evt) {
			if (!this.$el.contains(evt.target) && this.isOpen) {
				if (this.results.length && this.results[0]) {
					this.set_result(this.results[0],0);
				} else {
					if (this.activated) {
						this.$emit('no-results');
					}
				}
				this.results = [];
				this.isOpen = false;
				this.arrowCounter = -1;
			}
		},

		created() {
			this.nounce = Math.random().toString(36).substr(2,6);
		},
	},

	watch: {
		items: function(val) {
			this.results = val;
			this.isLoading = false;

			if (val.length > 0) {
				this.noResults = false;
			} else {
				if (this.cleared) {
					//this was cleared, not no results found, so reset the boolean
					this.cleared = false;
				} else {
					this.noResults = true;
				}
			}
		}
	},

	mounted: function() {
		document.addEventListener("click", this.handle_click_outside);
	},

	destroyed: function() {
		document.removeEventListener("click", this.handle_click_outside);
	}
}
</script>
<style>
.autocomplete {
	position: relative;
}

.autocomplete-results {
	padding: 10px;
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #ffffff;
	overflow: auto;
	width: 100%;
	z-index: 100;
	margin: 0;
	position: absolute;
}

.autocomplete-result {
	list-style: none;
	text-align: left;
	padding: 4px 2px;
	cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
	background-color: #E5F1F9;
	border-radius: 4px;
}

ul#autocomplete-results {
	list-style-type: none;
}

</style>